// extracted by mini-css-extract-plugin
export default {"section":"Section__section___QXZKA","fullHeight":"Section__fullHeight___kjzRR"};